export const confirmBeforeLeave = (event) => {
  event.preventDefault();
  // eslint-disable-next-line no-param-reassign
  event.returnValue = 'Are you sure you want to leave?';
};
